import axios from 'axios'
import { useQuery } from '@tanstack/react-query'

import { API_URL } from '../constants'

// Moved to educationModules type, remove on refactor of api
export type Quiz = {
  _id: string
  name: string
  languages: string[]
  questions: {
    _id: string
    question: {
      [language: string]: string
    }
    answers: {
      answer: {
        [language: string]: string
      }
      _id: string
    }[]
    submitted_answer?: {
      is_correct: boolean
      correct_answers: string[]
    }
  }[]
}

type QuizByIdVariables = {
  quiz_id: string
  campaign: string
}

type QuizByIdResponse = {
  _id: string
  name: string
  questions: {
    _id: string
    question: {
      [language: string]: string
    }
    answers: {
      answer: {
        [language: string]: string
      }
      _id: string
    }[]
    submitted_answer?: {
      is_correct: boolean
      correct_answers: string[]
    }
  }[]
  type: string
  languages: string[]
}

type QuizByIdResponseModified = QuizByIdResponse & {
  number_of_quiz_questions: number | null
  quiz_questions_with_answers: {
    id: string
    question_translations: { [language: string]: string }
    answers: {
      id: string
      answer_translations: { [language: string]: string }
      is_correct: boolean | null
    }[]
  }[]
}

// This endpoint is used for the preview state only
// Transfomr the quiz to match the quiz type of /training-videos/token/
const transoformQuiz = (data: QuizByIdResponse) => ({
  ...data,
  number_of_quiz_questions: data.questions.length ?? null,
  quiz_questions_with_answers: data.questions.map((question) => ({
    id: question._id,
    question_translations: question.question,
    answers: question.answers.map((answer) => ({
      id: answer._id,
      answer_translations: answer.answer,
      is_correct: null,
    })),
  })),
})

const getQuizById = async (params: QuizByIdVariables) => {
  const url = `${API_URL}/quizzes/get_quiz_by_id/?campaign=${params.campaign}&quiz_id=${params.quiz_id}`
  const { data } = await axios.get(url, { withCredentials: true })

  return data
}

export const useQuizById = (params: QuizByIdVariables, options = {}) =>
  useQuery<QuizByIdResponseModified>({
    queryKey: ['quizzes', params],
    queryFn: () => getQuizById(params),
    enabled: !!params.quiz_id && !!params.campaign,
    ...options,
    select: transoformQuiz,
  })
